/* eslint-disable */
import { FormControl, FormHelperText, Grid, Input, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import BusinessIcon from '@material-ui/icons/Business';
import FolderIcon from '@material-ui/icons/Folder';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_ACCOUNT_PROJECT_SELECTOR_SELECT_ACCOUNT, UI_ACCOUNT_PROJECT_SELECTOR_SELECT_PROJECT } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import helpers from '../../Support/Text';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Spinner from '../Spinner/Spinner.component';
import placeOrderStyles from './PlaceOrder.component.styles';
import PlaceOrderErrorMessage from './PlaceOrderErrorMessage.component';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * AccountProjectSelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const AccountProjectSelector = ({ actions, classes, services, onValidChange, currentAccountGlobal, disabled, defaultProject, isEdit, mandatoryFieldError }) => {
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [accounts, setAccounts] = useState(null);
  const [accountSelected, setAccountSelected] = useState(null);
  const [projectSelected, setProjectSelected] = useState(null);
  const [error, setError] = useState(false);

  /**
   * Validates account and project selected
   * @param {Object} account name of the account
   * @param {Object} project name of the account
   * @returns {void} void
   */
  const isAllValid = (account, project) => {
    if (account && account.isValidAccount && (!account.projectRequired || project)) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    (async () => {
      try {
        // request list of accounts from api
        setAccountsLoading(true);

        const loadedAccounts = await services.orderService.getPlaceOrderAccounts();
        setAccounts(loadedAccounts);
        const foundAccount = loadedAccounts.find((account) => account.id.trim() === helpers.getNumberFromBillTo(currentAccountGlobal));
        const selectedAccount = foundAccount || loadedAccounts[0];
        setAccountSelected(selectedAccount);

        if (isEdit) {
          setAccountsLoading(false);
          return;
        }
        let project = null;
        // account will be always the account currently selected in redux globally so only if project name is provided then use it
        if (defaultProject) {
          setProjectSelected(defaultProject);
        } else if (selectedAccount.projectRequired && selectedAccount.projects && selectedAccount.projects.length > 0) {
          [project] = selectedAccount.projects;
          setProjectSelected(selectedAccount.projects[0]);
        }

        onValidChange({ isValid: isAllValid(selectedAccount, project), account: selectedAccount, project, isFirstChange: true });
      } catch (ex) {
        setError(true);
      }
      setAccountsLoading(false);
    })();
  }, []);

  /**
   * Sets currently selected account and informs parent about changes
   * @param {string} accountId name of the account
   * @returns {void} void
   */
  const onSelectAccountHandler = async (accountId) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `accountProjectSelectorSelectAccount`,
        },
      },
      type: UI_ACCOUNT_PROJECT_SELECTOR_SELECT_ACCOUNT,
    });

    const account = accounts.find((el) => el.id === accountId);
    setAccountSelected(account);

    const userAccounts = await services.authService.getGroups();
    actions.filtersSelectAccount(userAccounts.find((el) => el.startsWith(account.id.trim())));

    let project = null;
    if (account.projectRequired && account.projects && account.projects.length > 0) {
      [project] = account.projects;
    }
    setProjectSelected(project);

    if (isAllValid(account, project)) {
      onValidChange({ isValid: true, account, project });
    } else {
      onValidChange({ isValid: false, account, project });
    }
    return;
  };

  /**
   * Sets currently selected project and informs parent about changes
   * @param {string} projectId name of the account
   * @returns {void} void
   */
  const onSelectProjectHandler = (projectId) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `accountProjectSelectorSelectProject`,
        },
      },
      type: UI_ACCOUNT_PROJECT_SELECTOR_SELECT_PROJECT,
    });

    const project = accountSelected.projects.find((el) => el.id === projectId);
    setProjectSelected(project);
    if (isAllValid(accountSelected, project)) {
      onValidChange({ isValid: true, account: accountSelected, project });
    } else {
      onValidChange({ isValid: false, account: accountSelected, project });
    }
    return;
  };

  /**
   * renders account selector
   * @returns {component} component
   */
  const renderAccountSelector = () => {
    return accounts ? (
      <FormControl fullWidth error={mandatoryFieldError}>
        <InputLabel htmlFor="place-order-account-selector">Account</InputLabel>
        <Select
          data-mf-replace-inner={MFSDR}
          disabled={disabled}
          fullWidth
          renderValue={(value) => (
            <React.Fragment>
              <BusinessIcon className={classes.dropdownIcon} />
              {accountSelected ? accountSelected.name : ``}
            </React.Fragment>
          )}
          value={accountSelected ? accountSelected.id : ``}
          onChange={(e) => onSelectAccountHandler(e.target.value)}
          input={<Input name="name" id="place-order-account-selector" />}
        >
          {accounts.map((account) => {
            return (
              <MenuItem value={account.id} key={account.id} data-mf-replace-inner={MFSDR}>
                <Grid container>
                  <Grid item xs={12}>
                    {account.name}
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="caption" className={classes.opacity05}>
                      Account ID: {account.id.trim()}
                    </Typography>
                  </Grid>
                </Grid>
              </MenuItem>
            );
          })}
        </Select>
        {!disabled && <FormHelperText>Select an Account for your concrete order</FormHelperText>}
      </FormControl>
    ) : null;
  };

  /**
   * renders project selector
   * @returns {component} component
   */
  const renderProjectSelector = () => {
    if (!accountSelected) {
      return null;
    }

    if (accountSelected.isValidAccount && accountSelected.projects && accountSelected.projects.length > 0) {
      let dropDownValue = `no-project`;
      if (!accountSelected.projectRequired) {
        dropDownValue = projectSelected ? projectSelected.id : `no-project`;
      } else {
        dropDownValue = projectSelected ? projectSelected.id : accountSelected.projects[0].id;
      }
      let labelValue = `No Project`;
      if (accountSelected.projectRequired) {
        labelValue = accountSelected.projects[0].name;
      }
      let helperText = ``;
      if (!disabled) {
        helperText = accountSelected.projectRequired ? (
          <FormHelperText>Select a Project</FormHelperText>
        ) : (
          <FormHelperText>Select a Project, if applicable</FormHelperText>
        );
      }

      return (
        <FormControl fullWidth key={accountSelected.name} error={mandatoryFieldError}>
          <InputLabel htmlFor="place-order-project-selector">Project</InputLabel>
          <Select
            data-mf-replace-inner={MFSDR}
            disabled={disabled}
            fullWidth
            className={classes.dropDown}
            renderValue={(value) => (
              <React.Fragment>
                <FolderIcon className={classes.dropdownIcon} />
                {projectSelected ? projectSelected.name : labelValue}
              </React.Fragment>
            )}
            value={dropDownValue}
            onChange={(e) => onSelectProjectHandler(e.target.value)}
            input={<Input name="name" id="place-order-project-selector" />}
          >
            {!accountSelected.projectRequired && (
              <MenuItem value="no-project" key="no-project">
                No Project
              </MenuItem>
            )}
            {accountSelected.projects &&
              accountSelected.projects.length &&
              accountSelected.projects.map((project) => {
                return (
                  <MenuItem value={project.id} key={project.id} data-mf-replace-inner={MFSDR}>
                    {project.name}
                  </MenuItem>
                );
              })}
          </Select>
          {helperText}
        </FormControl>
      );
    }
    return null;
  };

  /**
   * Renders edit project selector. This is not editable atm so we just display value and user cannot change it
   * @returns {component} component
   */
  const renderEditProjectSelector = () => {
    return accounts ? (
      <FormControl fullWidth key={accountSelected.name}>
        <InputLabel htmlFor="place-order-edit-project-selector">Project</InputLabel>
        <Select
          disabled
          fullWidth
          className={classes.dropDown}
          renderValue={(value) => (
            <React.Fragment>
              <FolderIcon className={classes.dropdownIcon} />
              {defaultProject.name || `No Project`}
            </React.Fragment>
          )}
          value={defaultProject.name || `No Project`}
          input={<Input name="name" id="place-order-edit-project-selector" />}
        >
          {!defaultProject.name && (
            <MenuItem value="no-project" key="no-project">
              No Project
            </MenuItem>
          )}
        </Select>
      </FormControl>
    ) : null;
  };

  /**
   * Renders edit account selector. This is not editable atm so we just display value and user cannot change it
   * @returns {component} component
   */
  const renderEditAccountSelector = () => {
    return accounts ? (
      <FormControl fullWidth key={accountSelected.name}>
        <InputLabel htmlFor="place-order-edit-account-selector">Account</InputLabel>
        <Select
          disabled
          fullWidth
          className={classes.dropDown}
          renderValue={(value) => (
            <React.Fragment>
              <FolderIcon className={classes.dropdownIcon} />
              {accountSelected.name}
            </React.Fragment>
          )}
          value={accountSelected.name}
          input={<Input name="name" id="place-order-edit-account-selector" />}
        />
      </FormControl>
    ) : null;
  };

  return (
    <React.Fragment>
      {accountsLoading ? (
        <Spinner />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {isEdit ? renderEditAccountSelector() : renderAccountSelector()}
          </Grid>
          <Grid item xs={12}>
            {isEdit ? renderEditProjectSelector() : renderProjectSelector()}
          </Grid>
          {!isEdit && accountSelected && (!accountSelected.isValidAccount || (accountSelected.projectRequired && !accountSelected.projects)) && (
            <Grid item xs={12}>
              <PlaceOrderErrorMessage
                message={
                  <Typography variant="body2" className={classes.errorText}>
                    There is an issue with the selected Account that restricts it from online ordering at this time. Please{` `}
                    <a
                      className={classes.errorText}
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                    >
                      Call Boral
                    </a>
                    {` `}
                    for more information and to place your order.
                  </Typography>
                }
              />
            </Grid>
          )}
          {error && (
            <Grid item xs={12}>
              <PlaceOrderErrorMessage
                message={
                  <Typography variant="body2" className={classes.errorText}>
                    There is an issue with online ordering at this time. Please{` `}
                    <a
                      className={classes.errorText}
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                    >
                      Call Boral
                    </a>
                    {` `}
                    for more information and to place your order.
                  </Typography>
                }
              />
            </Grid>
          )}
        </Grid>
      )}
    </React.Fragment>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
AccountProjectSelector.propTypes = {
  actions: PropTypes.object.isRequired,
  services: PropTypes.object.isRequired,
  defaultProject: PropTypes.object,
  classes: PropTypes.object.isRequired,
  currentAccountGlobal: PropTypes.string.isRequired,
  onValidChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isEdit: PropTypes.bool,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentAccountGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(AccountProjectSelector);
